import * as types from "@/store/mutation-types";
import api from "@/services/api/exposed";
import { convertDateTimes } from "@/utils/utils";

const getters = {
  cancelVisitData: (state) => state.data,
  cancelVisitStatus: (state) => state.status,
  doCancelVisitLoading: (state) => state.loading,
};

const actions = {
  getCancelVisitData({ commit }, identifier) {
    return new Promise((resolve) => {
      api
        .getCancelableMeetingById(identifier)
        .then((response) => {
          if (response.status === 200) {
            commit(types.ECANCEL_VISIT_DATA, response.data);
            resolve();
          }
        })
        .catch(() => {
          commit(types.ERROR, "CANCEL_VISIT_NOT_FOUND");
        });
    });
  },
  cancelVisit({ commit }, identifier) {
    commit(types.ECANCEL_VISIT_LOADING, true);
    return new Promise((resolve) => {
      api
        .cancelMeeting(identifier)
        .then((response) => {
          if (response.status === 200) {
            commit(types.ECANCEL_VISIT_LOADING, false);
            commit(types.ECANCEL_VISIT_STATUS, "success");
            resolve();
          }
        })
        .catch(() => {
          commit(types.ECANCEL_VISIT_LOADING, false);
          commit(types.ECANCEL_VISIT_STATUS, "error");
          resolve();
        });
    });
  },
};

const mutations = {
  [types.ECANCEL_VISIT_DATA](state, data) {
    convertDateTimes(data);
    state.data = data;
  },
  [types.ECANCEL_VISIT_STATUS](state, status) {
    state.status = status;
  },
  [types.ECANCEL_VISIT_LOADING](state, isLoading) {
    state.loading = isLoading;
  },
};

const state = {
  data: {},
  status: "pending",
  loading: false,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
